import editTabsMixin from '../../mixins/editTabsMixin'

const TAB_KEY = 'assignedVehicles'
const DATA_KEY = 'vehicles'
export default {
  mixins: [
    editTabsMixin
  ],

  data () {
    return {
      assignedVehiclesTabKey: TAB_KEY
    }
  },

  computed: {
    assignedVehiclesEditConfig () {
      return {
        title: this.$t('base/user.assigned_vehicles'),
        key: TAB_KEY,
        apiConfig: {
          get: {
            module: 'base',
            route: `user/${this.$route.params.id}/assigned-vehicles`
          },
          post: {
            module: 'base',
            route: `user/${this.$route.params.id}/assigned-vehicles`
          }
        },
        hiddenFormKeys: [
          DATA_KEY
        ],
        modifyDataBeforeSend: (event) => this.modifyAssignedVehiclesData(event),
        tabContent: [
          {
            component: this.tabActionsComponent,
            title: this.$t('base/user.assigned_vehicles'),
            showBackButton: {
              onGoBack: () => this.goBack()
            }
          },
          {
            component: this.vehiclePickerComponent,
            dataKey: DATA_KEY,
            treeviewConfig: {
              selectable: true,
              activatable: true
            },
            inputFieldConfig: {
              label: this.$t('base/user.assigned_vehicles')
            }
          }
        ]
      }
    }
  },

  methods: {
    modifyAssignedVehiclesData (event) {
      const { copiedData } = event || {}

      if (copiedData?.[DATA_KEY]?.length) {
        copiedData[DATA_KEY] = copiedData[DATA_KEY].map(item => item?.id || item).filter(item => item)
      }
      else {
        delete copiedData[DATA_KEY]
      }

      return copiedData
    }
  }
}
